var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',[_c('table',{staticClass:"table table-bordered table-hover",attrs:{"id":_vm.tableId}})]),_vm._v(" "),(this.stateIsLoading)?_c('div',[_c('i',{staticClass:"fa fa-refresh fa-spin"})]):_vm._e(),_vm._v(" "),(this.stateHasError)?_c('div',{staticClass:"text-danger",staticStyle:{"padding":"10px"}},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" Failed to load data. Your session may have expired.\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/common/TableEx.vue